"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MAX_DIGITS = 4;
class PaymentToken {
    constructor(gatewayTokens, cardInformation) {
        this.gatewayTokens = gatewayTokens;
        this.getGatewayTokens = () => this.gatewayTokens;
        this.encode = () => {
            return Buffer.from(JSON.stringify(this)).toString('base64');
        };
        const cardNumber = cardInformation.cardNumber.trim();
        this.cardNumberLastFourDigits = cardNumber.substring(cardNumber.length - MAX_DIGITS);
        this.cardExpirationDate = cardInformation.cardExpiration;
    }
}
exports.default = PaymentToken;
